export const contractTypeOptions = [
  {
    label: "Private Office",
    value: "private_office",
  },
  {
    label: "BTS",
    value: "bts",
  },
  {
    label: "Endereço fiscal",
    value: "fiscal_address",
  },
  {
    label: "Posição fixa",
    value: "fixed_position",
  },
];

export const renewalIndicatorOptions = [
  {
    label: "IGPM",
    value: "igpm",
  },
  {
    label: "IPCA",
    value: "ipca",
  },
];

export const cancellationReasonOptions = [
  {
    label: "Troca por uma opção com menor custo",
    value: "Troca por uma opção com menor custo",
  },
  {
    label: "Redução do número de colaboradores",
    value: "Redução do número de colaboradores",
  },
  {
    label: "Baixa adesão do time ao uso da sala",
    value: "Baixa adesão do time ao uso da sala",
  },
  {
    label: "Local não atende mais à necessidade geográfica da equipe",
    value: "Local não atende mais à necessidade geográfica da equipe",
  },
  {
    label: "Necessidade de um espaço para uma equipe maior",
    value: "Necessidade de um espaço para uma equipe maior",
  },
  {
    label: "Necessidade de um espaço para uma equipe menor",
    value: "Necessidade de um espaço para uma equipe menor",
  },
  {
    label: "Problemas e/ou má experiência com o uso do espaço",
    value: "Problemas e/ou má experiência com o uso do espaço",
  },
  {
    label: "Cliente não acordou com valores de reajuste",
    value: "Cliente não acordou com valores de reajuste",
  },
  {
    label: "Outros",
    value: "Outros",
  },
];
